import classnames from 'classnames';

import classes from './index.module.css';

export const Link = ({
  title,
  className,
  href,
  isActive,
  showMobile = false,
  onlyMobile = false,
  onClick,
  id,
}) => {
  const getChild = () => {
    if (onClick) {
      return (
        <span onClick={onClick} className={classnames('font-14', classes.link, className)}>
          {title}
        </span>
      );
    }

    return (
      <a href={href} className={classnames('font-14', classes.link, className)}>
        {title}
      </a>
    );
  };

  return (
    <li
      className={classnames('p-0 m-0', {
        [classes.activeLink]: isActive,
        'd-none d-lg-block': !showMobile && !onlyMobile,
        'd-block d-lg-none': onlyMobile,
      })}
      id={id}
    >
      {getChild()}
    </li>
  );
};

export const ExploreLink = ({ className, isActive }) => (
  <li
    className={classnames(className, {
      [classes.activeLink]: isActive,
    })}
    id="explorer-dropdown"
  >
    <a href="/explore/" className={classnames('font-14', classes.link, classes.exploreLink)}>
      Careers
    </a>
  </li>
);
